// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__1vXv5","field":"Search_field__NMGLt"};